const VERSION = '2.0.11b'
export default VERSION
